<template>
  <div id="app">
    <div id="navigation">
      <ul>
        <li>
          <img src="../../assets/logo.png">
        </li>
        <li><span></span></li>
        <li><span>智慧校园云平台</span></li>
        <li>
          <input type="radio" name="nav" id="1"/>
          <label for="1"><a @click="$router.push({name: 'home'})">首页</a></label>
        </li>
        <!-- <li>
          <input type="radio" name="nav" id="2"/>
          <label for="2"><a @click="$router.push({name: 'product'})">产品介绍</a></label>
        </li> -->
        <li>
          <input type="radio" name="nav" id="3"/>
          <label for="3"><a @click="$router.push({name: 'about'})">关于我们</a></label>
        </li>
        <li>
          <v-popover offset="16" :disabled="!isEnabled" :delay="{ show: 100, hide: 100 }">
            <!-- <input type="button" name="nav" id="4"/> -->
            <button style="width: 5em;border-radius: 3px;background-color:#a0d36e;color:#fff;border:none">登录</button>
            <template slot="popover">
              <div class="login-btn">
                <button v-close-popover @click="openWindow('teacher')">教师登录</button><br>
                <button v-close-popover @click="openWindow('parent')">家长登录</button><br>
                <button v-close-popover @click="openWindow('student')" style="margin-bottom: 0;">学生干部登录</button>
              </div>
            </template>
          </v-popover>
        </li>
      </ul>
    </div>
    <div style="margin-top: 70px;min-height: 80vh">
      <transition :name="transitionName">
        <router-view/>
      </transition>
    </div>
    <div id="footer">
      <div class="conspire">
        <a href="/partner.html#/company" target="view_window">渠道合作联系</a>
        <a href="/partner.html#/school" target="view_window">学校合作联系</a>
      </div>
      <div class="nav">
        <a @click="$router.push({name: 'home'})">首页</a>
        <!-- <a>家校沟通</a>
        <a>教务管理</a>
        <a>德育管理</a>
        <a>综合素质评定</a> -->
        <a @click="$router.push({name: 'about'})">关于我们</a>
      </div>
      <p>北京君羊教育科技有限公司© 版权所有 <a style="color:rgb(160, 211, 110);" href="http://beian.miit.gov.cn" target="_blank">京ICP备18044407号-1</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      transitionName: 'slide-left',
      isEnabled: true
    }
  },
  watch: {
    '$route' (to, from) {
      if (String(to.path).endsWith('index.html') || (String(from.path).endsWith('about.html') && String(to.path).endsWith('product.html'))) {
        this.transitionName = 'slide-right'
        return
      }
      this.transitionName = 'slide-left'
    }
  },
  methods: {
    openWindow(key) {
      switch (key) {
        case 'teacher':
          window.open('https://edu.xiaohejia.com/', '_blank')
          break
        case 'parent':
          window.open('https://edu.xiaohejia.com/', '_blank')
          break
        case 'student':
          window.open('https://stu.xiaohejia.com', '_blank')
          break
      }
    }
  }
}
</script>


<style lang="less">
.hidden{
  display: hidden;
}
.login-btn{
  button {
    padding: 5px 0;
    width: 8em;
    margin-bottom: 10px;
  }
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
input[type="radio"]:checked+label {
  background-color: #a0d36e !important;
}
#navigation {
  height: 70px;
  text-align: center;
  overflow: hidden;
  position: fixed;
  top: 0;
  width: 100vw;
  background-color: white;
  z-index: 1000;
  ul {
    overflow: hidden;
    text-align: center;
    display: table;
    margin-left: auto;
    margin-right: auto;
    li {
      float: left;
      vertical-align: middle;
      display: table-cell;
      list-style: none;
      line-height: 35px;
      font-size: 14px;
      margin: 0 15px;
      input {
        display: none;
      }
      &:nth-child(1) {
        margin-right: 18px;
      }
      &:nth-child(2) {
        width: 1px;
        height: 35px;
        background-color: #a0d36e;
        margin-right: 18px;
      }
      &:nth-child(3) {
        font-size: 14px;
        color: #a0d36e;
        margin-right: 278px;
      }
      a {
        display: block;
        padding: 0 15px;
        cursor:pointer;
        &:hover {
          background-color: #a0d36e;
          color: #fff;
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  #navigation {
    ul {
      li {
        &:nth-child(3) {
          margin-right: 100px
        }
      }
    }
  }
}
#footer {
  background-color: #eee;
  margin-top: 40px;
  .conspire {
    text-align: center;
    padding: 36px;
    a {
      padding: 16px 50px;
      margin: 0px 90px;
      background-color: #a0d36e;
      color: white;
    }
  }
  .nav {
    margin-top: 50px;
    text-align: center;
    a {
      margin: 0 16px;
    }
  }
  p {
    padding-bottom: 36px;
    color: #666
  }
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
    will-change: transform;
    transition: all .3s;
    position: absolute;
    width:100%;
    left:0;
}
 .slide-right-enter, .slide-right-leave-to{
  transform: translateX(-100%);
}
.slide-right-leave-active  {
    transform: translateX(100%);
}
.slide-left-enter, .slide-left-leave-to {
    transform: translateX(100%);
}
.slide-left-leave-active {
    transform: translateX(-100%);
}

.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &.popover {
    @color: #f9f9f9;

    .popover-inner {
      background: @color;
      color: black;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, .1);
    }

    .popover-arrow {
      border-color: @color;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}
</style>
